// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Bridge = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      d="M4.327 3.743v10.514M13.673 3.743v10.514M16.594 8.076c-1.84 0-2.922-2.449-2.92-4.333 0 2.545-2.129 4.673-4.674 4.673S4.327 6.288 4.327 3.743c0 1.884-1.082 4.333-2.92 4.333M10.752 8.076v3.845M7.248 8.076v3.845M1.406 11.92h15.188"
    />
  </svg>
);
const ForwardRef = forwardRef(Bridge);
export default ForwardRef;
